import { Input } from 'antd';
import { Alert } from '@insight-health-ai/roseate/components';

type FlowBuilderProps = {
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
};

export const FlowBuilder = ({ value, onChange, error }: FlowBuilderProps) => {
  return (
    <div className="space-y-3">
      {error ? (
        <Alert appearance="error" message={`Invalid JSON: ${error}`} />
      ) : null}
      <Input.TextArea
        className="font-mono"
        rows={24}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Paste flow JSON ({steps, triggers, custom_variables})"
      />
    </div>
  );
};

export type { FlowBuilderValue } from './FlowBuilder.types';
